import { inject } from 'mobx-react';
import * as React from 'react';

import { datadogRum } from '@datadog/browser-rum-slim';

const DataDogRUMComponent = inject('experiment')(({ experiment }) => {
  // this is to run the DD RUM code only on the client, could have used the useEffect hook
  // but that would run later and we want this to run as early as possible
  if (typeof window !== 'undefined') {
    datadogRum.onReady(() => {
      Object.values(experiment?.exposures).forEach(({ name, bucket }: any) => datadogRum.addRumGlobalContext(name, bucket));
    });
  }

  return null;
});

// memo is needed to avoid rerendering when the user changes destination on an SRP or form data on a PDP
export const DataDogRUM = React.memo(DataDogRUMComponent);
